import { Component, OnInit, Input, Output , EventEmitter} from '@angular/core';
import { IFAListService } from '@ifa/ifa-list.service';
import { ToastrService } from 'ngx-toastr';
import { IFA } from '@ifa/ifa-list-container/ifa-list-container.model';
import { MatDialog } from '@angular/material/dialog';
import { IfaTagDialogComponent } from '../ifa-tag-dialog/ifa-tag-dialog.component';
import { IfaBlockDialogComponent } from '../ifa-block-dialog/ifa-block-dialog.component';
import { ErrorHandler } from '@root/utils/error-handler.service';
import { IfaConfirmationComponent } from '@ifa/ifa-confirmation/ifa-confirmation.component';


@Component({
  selector: 'app-ifa-list-container',
  templateUrl: './ifa-list-container.component.html',
  styleUrls: ['./ifa-list-container.component.scss'],
})
export class IfaListContainerComponent implements OnInit {


  @Input() ifaList: IFA[] = [];

  @Output() refersh = new  EventEmitter();

  panelMap: { [key: string]: boolean } = {};

  objIFA: any;

  constructor(
    private ifaListService: IFAListService,
    private errorHandler: ErrorHandler,
    private toastr: ToastrService,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
  }

 

  public onRemoveTag(ifa: IFA, tag: any) {
    const dialogRef = this.dialog.open(IfaConfirmationComponent, {
      width: '600px',
      data: { value: ifa, tag },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result.status === true)  {
       const obj = {
        arnCode: result.data.value.arnCode,
        id: result.data.tag.tagId,
      };
     this.ifaListService.deleteUserInTag(obj).subscribe(
      (response) => {
        if (response.status === 0) {
          this.toastr.success(response.message);
          this.refersh.emit();
        }
        this.errorHandler.handleError(response);
      },
      (error) => {
        this.errorHandler.handleError(error);
      }
    );
      }
    });
  }

  public openAddTagDialog(ifa: IFA, mode: string) {
    const dialogRef = this.dialog.open(IfaTagDialogComponent, {
      width: '600px',
      data: { value: mode, ifa },
    });
    dialogRef.afterClosed().subscribe((status) => {
      if (status) {
        this.refersh.emit();
      }
    });
  }

  public openBlockOrUnblockDialog(ifa: IFA, device?: any) {
    const isDevice = !!device;
    const isBlock  = isDevice ? !device.status : ifa.isBlocked;
    const dialogRef = this.dialog.open(IfaBlockDialogComponent, {
      width: '486px',
      data: { ifa, device, isBlock },
    });

    dialogRef.afterClosed().subscribe((response) => {
      if(response){
        if(isDevice){
          this.blockOrUnblockDevice(ifa, device, isBlock);
        }else{
            this.blockIFA(ifa, isBlock);
        }
      }
    });
  }

  private blockIFA(ifa: any, status: boolean){
    this.objIFA = {
      id: ifa.id,
      status: status ? 1 : 0
    };

    this.ifaListService.blockIFA(this.objIFA).subscribe(
      (response) => {
        if (response.status === 0) {
          this.toastr.success(response.message);
          this.refersh.emit();
        }
        this.errorHandler.handleError(response);
      },
      (error) => {
        this.errorHandler.handleError(error);
      }
    );
  }

  private blockOrUnblockDevice(ifa:any , device: any , status: boolean){
    this.objIFA = {
      id: ifa.id,
      deviceId: device.deviceId,
      status: status ? 0 : 1 
    };
    this.ifaListService.blockDevice(this.objIFA).subscribe(
      (response) => {
        if (response.status === 0) {
          this.toastr.success(response.message);
          this.refersh.emit();
        }
        this.errorHandler.handleError(response);
      },
      (error) => {
        this.errorHandler.handleError(error);
      }
    );
  }
 
}
